var React = require('react');

function IconInput (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z","key":1})]);
}

IconInput.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = IconInput;

IconInput.default = IconInput;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-input.svg
// module id = 533
// module chunks = 0